import gql from "graphql-tag";

// TODO should actually fetch way less data here
// and fetch more data upon opeining the registered team view
// Same goes for the my/competitors view
export const List = gql`
query ListTeams($filter: TableTeamFilterInput, $limit: Int, $nextToken: String) {
  listTeams(filter: $filter, limit: $limit, nextToken: $nextToken) {
    nextToken
    items {
      teamId
      userId
      user {
        userId
        given_name
        family_name
        email
      }
      name
      robotName
      robotNumber
      event {
        id
        title
      }
      competition {
        code
        i18n_title
        teamMemberLimit
      }
      members
      purchaseOrders {
        purchaseOrderId
        status
      }
      payments {
        paymentId
        voistlus
        success
        total
      }
      technicalControl {
        status
      }
    }
  } 
}
`;

export const Get = gql`
query GetTeam($userId: ID!, $teamId: ID!) {
  getTeam(userId: $userId, teamId: $teamId) {
      teamId
      userId
      name
      robotName
      robotNumber
      hasAcceptedCompetitionRules
      eventId
      event {
        id
        title
      }
      competition {
        id: competitionId
        code
        i18n_title
        teamMemberLimit
        rulesurl: competitionRulesURL
      }
      mentor
      members
      createdBy
      createdAt
      purchaseOrders {
        purchaseOrderId
        status
      }
      payments {
        paymentId
        voistlus
        success
        total
      }
      technicalControl {
        status
        comments
        createdAt
      }
    }
}
`;

// TODO make th
export const ListEvents = gql`
  query ListEvents (
    $filter: TableEventFilterInput, 
    $limit: Int,
    $nextToken: String
  )
  {
    listEvents(filter: $filter, limit: $limit, nextToken: $nextToken) {
      nextToken
      items {
        value: id 
        text: title
        location
        type
        competitions {
          id: competitionId
          code
          date
          beginTime
          endTime
          organizer
    	  competitionRulesURL 
          teamMemberLimit
          participantLimit
      	  robotRequired
      	  published
          difficulty
          i18n_title
          i18n_description
        }
      }
    }
  }
`;

export const Update = gql`
  mutation UpdateTeam($input: UpdateTeamInput!) {
    updateTeam(input: $input) {
      teamId
      competitionId
      eventId
      name
      robotName
      hasAcceptedCompetitionRules
      mentor
      members
    }
  }
`;


// TODO see ei peaks siin olema
export const UpdatePayment = gql`
  mutation UpdatePayment($input: UpdatePaymentInput!) {
    updatePayment(input: $input) {
        paymentId
        userId
	teamIds
        voistlus
    }
  }
`;

export const CreatePayment = gql`
  mutation CreatePayment($input: CreatePaymentInput!) {
    createPayment(input: $input) {
	userId
	voistlus
	teamIds
    }
  }
`;

export const ListCompetitionUsers = gql`
query ListCompetitionUsers($competitionId: ID!) {
  listCompetitionUsers(competitionId: $competitionId) {
    name
    robotName
    userId
    country_of_residence
    occupation
    occupation_details
    given_name
    family_name
    email
  } 
}
`;

export const Delete = gql`
  mutation DeleteTeam($input: DeleteTeamInput!) {
    deleteTeam(input: $input) {
      teamId
    }
  }
`;



// WEBPACK FOOTER //
// ./src/private/admin/containers/Teams/graphql.js